export const dFlexCenter = {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
}

export const dFlexSpaceBetween = {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between'
}

export const dFlexSpaceAround = {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-around'
}

export const dFlexSpaceEvenly = {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-evenly'
}

export const dFlexStart = {
    display: 'flex',
    alignItems: 'flex-start',
    justifyContent: 'flex-start'
}
